module.exports = __webpack_public_path__ + "static/media/mars.d6756613.png";